import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { IrisButtonModule } from '@sondermind/iris/button';
import { DirectiveModule } from '@sondermind/utilities/directives';

import { SonderModalModule } from '@sondermind/core/design/sonder-modal/sonder-modal.module';

import { TooltipComponent } from './components/tooltip/tooltip.component';

@NgModule({
  imports: [
    CommonModule,

    SonderModalModule,
    IrisButtonModule,
    DirectiveModule,

    MatTooltipModule
  ],
  providers: [
  ],
  declarations: [
    TooltipComponent
  ],
  exports: [
    TooltipComponent
  ]
})
export class TooltipModule {}
